import { BaseAdapter } from "./base-adapter";
import { EventType } from "../types";
import type { TEvent } from "../types";
import { TrackEventKpActionType } from "../types";

declare global {
  interface Window {
    trackEventKp?: (params: {
      category: string;
      label: string;
      action: string;
      [key: string]: unknown;
    }) => void;
  }
}

/**
 * KP tracking adapter
 * Handles tracking events using the window.trackEventKp function
 * Only tracks specific events: ADD_TO_CART, ORDER_PLACED, and CHECKOUT_INITIATED
 */
export class KpAdapter extends BaseAdapter {
  public readonly name = "kp-tracker";

  /**
   * Constructor
   * @param config Configuration for the adapter
   */
 
  /**
   * Initialize the KP tracking adapter
   */
  public async initialize(): Promise<void> {
    if (this.initialized) {
      console.log("KP Tracker: Already initialized");
      return;
    }

    // Skip initialization if running on server
    if (typeof window === "undefined") {
      console.log("KP Tracker: Skipping initialization on server");
      return;
    }

    
    this.initialized = true;
  }

  /**
   * Track an event with KP tracking
   * Only tracks specific events: ADD_TO_CART, ORDER_PLACED, and CHECKOUT_INITIATED
   * @param event The event to track
   */
  public async trackEvent(event: TEvent): Promise<void> {
    if (!this.initialized || typeof window === "undefined") {
      console.warn("KP Tracker: Cannot track event, adapter not initialized", event.type);
      return;
    }

    console.log(`KP Tracker: Tracking event ${event.type}`);

    // Check if window.trackEventKp exists
    if (!window.trackEventKp) {
      console.warn("KP Tracker: trackEventKp function not found on window object");
      return;
    }

    // Use type assertion to handle all event types in switch
    switch (event.type as string) {
      case EventType.ADD_TO_CART:
        // Call the global trackEventKp function
        window.trackEventKp({
          category: EventType.ADD_TO_CART,
          label: EventType.ADD_TO_CART,
          action: TrackEventKpActionType.CLICK,
        });
        break;
      case EventType.CHECKOUT_INITIATED:
        // Call the global trackEventKp function
        window.trackEventKp({
          category: EventType.CHECKOUT_INITIATED,
          label: EventType.CHECKOUT_INITIATED,
          action: TrackEventKpActionType.CLICK,
        });
        break;
      case EventType.CHECKOUT_STARTED:
        window.trackEventKp({
          category: EventType.CHECKOUT_INITIATED,
          label: EventType.CHECKOUT_INITIATED,
          action: TrackEventKpActionType.CLICK,
        });
        break;
      case EventType.ORDER_PLACED:
        window.trackEventKp({
          category: EventType.ORDER_PLACED,
          label: EventType.ORDER_PLACED,
          action: TrackEventKpActionType.AUTOMATED,
        });
        break;
      case EventType.CUSTOM:
        console.warn("KP Tracker: Custom event switch case", event);
        if(event.name === EventType.ORDER_PLACED) {
          window.trackEventKp({
            category: EventType.ORDER_PLACED,
            label: EventType.ORDER_PLACED,
            action: TrackEventKpActionType.AUTOMATED,
          });
        }
        break;
      default:
        // Ignore other events
        break;
    }
  }
}
